module.exports = "/_next/static/images/b9cd93267f870d3b403b329ffb47f757-nu-card-xs@1x.jpg";